import { initializeApp, getApps, FirebaseApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';

/**
 * Firebase configuration and initialization
 * This is the single source of truth for Firebase initialization in the app
 */
const firebaseConfig = {
  apiKey: "AIzaSyCR9_J--ElJBZJ1n6E_wlcjLCZyenmf0MI",
  authDomain: "utme-past-questions-2010-2018.firebaseapp.com",
  projectId: "utme-past-questions-2010-2018",
  storageBucket: "utme-past-questions-2010-2018.firebasestorage.app",
  messagingSenderId: "11586823034",
  appId: "1:11586823034:web:d625a4162bd0f19457ecc3"
};

// Initialize Firebase
let app: FirebaseApp;

try {
  if (getApps().length === 0) {
    app = initializeApp(firebaseConfig);
    console.log('Firebase initialized for the first time');
  } else {
    app = getApps()[0];
    console.log('Using existing Firebase instance');
  }
} catch (error) {
  console.error('Error initializing Firebase:', error);
  throw error; // Re-throw to prevent the app from running with uninitialized Firebase
}

export const auth = getAuth(app);
export const db = getFirestore(app);

// Function to test Firebase connection
export const testFirebaseConnection = async () => {
  try {
    await getFirestore(app);
    return true;
  } catch (error) {
    console.error('Firebase connection test failed:', error);
    return false;
  }
};

export default app; 